import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function PopularCategories() {
  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            <a href="#categories">热门分类</a>
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            按类型浏览，快速找到你喜欢的动漫
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300/60 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 font-heading">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.count} 部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}